import api from 'plugin/api';
import { API_URL } from 'types/const';
import format from 'utils/string/format';

/**
 * 코드 목록 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.codeGroup 상위 코드
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.standard.code.default, { params });
}

/**
 * 코드 등록
 * @param {Object} data 요청 데이터
 * @param {string} data.codeGroup 상위 코드
 * @param {string} data.codeCd 코드
 * @param {string} data.codeNmKr 코드명
 * @param {'Y' | 'N'} data.useYn 사용 여부
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  return api.post(API_URL.standard.code.default, data);
}

/**
 * 코드 수정
 * @param {number} seq 코드 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.codeNmKr 코드명
 * @param {'Y' | 'N'} data.useYn 사용 여부
 * @return {Object} 응답 데이터
 */
async function requestUpdate(seq, data) {
  return api.put(format(API_URL.standard.code.inform, { seq }), data);
}

export { requestList, requestInsert, requestUpdate };
